export const serviceConnectionType = {
    'AG': 'Agricultural',
    'CB': 'Combined',
    'CM': 'Commercial',
    'IN': 'Industrial',
    'PP': 'Power Prod',
    'RS': 'Residential',
    '': ''
};

export const serviceConnectionMeterType = {
  'ME': 'Metered',
  'MU': 'Metered/Unmetered',
  'UM': 'Unmetered',
  'UN': 'Unknown',
  '': ''
};